﻿
import { ApplicationInsights } from '@microsoft/applicationinsights-web'

type AppInsightsConfig = {
    analyticsEnabled: () => boolean;
    key: string;
}
const aiConfig: AppInsightsConfig = window['AppInsights'] || { analyticsEnabled: () => false, key: '' };
if (aiConfig.analyticsEnabled()) {
    const appInsights = new ApplicationInsights({
        config: {
            instrumentationKey: aiConfig.key
                /* ...Other Configuration Options... */
        }
    });
    appInsights.loadAppInsights();
    appInsights.trackPageView(); // Manually call trackPageView to establish the current user/session/pageview
}

